// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __ } from '@wordpress/i18n';

/**
 * The valid recipe types
 * @type {Object}
 */
const recipeTypes = {
	user: {
		id: 'user',
		name: escapeHTML( __( 'Logged-in users', 'uncanny-automator' ) ),
		description: escapeHTML( __( 'Recipe will be triggered by logged-in WordPress users.', 'uncanny-automator' ) ),
	},
	anonymous: {
		id: 'anonymous',
		name: escapeHTML( __( 'Everyone', 'uncanny-automator' ) ),
		description: escapeHTML( __( 'Recipe will be triggered by logged-in WordPress users or logged out visitors.', 'uncanny-automator' ) ),
	},
};

export default recipeTypes;
